import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconCreditCard = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <rect
        x="128"
        y="256"
        width="768"
        height="512"
        rx="64"
        ry="64"
        fill={fill}
        opacity="0.3"
      />

      <rect x="192" y="384" width="640" height="64" rx="32" ry="32" fill={fill} />
      <rect x="192" y="512" width="192" height="64" rx="32" ry="32" fill={fill} />
    </svg>
  )
}

export default IconCreditCard
